(() => {
  const triggers = document.querySelectorAll('[data-machine-finish-trigger]');
  const layouts = document.querySelectorAll('[data-machine-finish-layout]');
  if (!triggers.length || !layouts.length) return;

  function setActive(id) {
    triggers.forEach((trigger) => {
      const isActive = trigger.dataset.machineFinishTrigger === id;
      trigger.classList.toggle('image-hotspots__point--light', isActive);
      trigger.classList.toggle('image-hotspots__point--dark', !isActive);
      trigger.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      if (isActive) {
        const section = trigger.closest('.image-hotspots');
        if (!section) return;
        const img = section.querySelector('.image-hotspots__image');
        const source = section.querySelector('picture source');
        const dt = trigger.dataset.activeImageDt;
        const mb = trigger.dataset.activeImageMb;
        if (img && dt) img.src = dt;
        if (source && mb) source.srcset = mb;
      }
    });
    layouts.forEach((layout) => {
      const isActive = layout.dataset.machineFinishLayout === id;
      if (isActive) {
        layout.removeAttribute('hidden');
      } else {
        layout.setAttribute('hidden', '');
      }
    });
  }

  function slowScrollTo(el) {
    const header = document.querySelector('xo-sticky.xo-header__body');
    const offset = (header?.offsetHeight || 0) + 16;
    const start = window.scrollY;
    const distance = el.getBoundingClientRect().top - offset;
    const t0 = performance.now();
    (function step(now) {
      const t = Math.min(1, (now - t0) / 1100);
      const eased = t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2;
      window.scrollTo(0, start + distance * eased);
      if (t < 1) requestAnimationFrame(step);
    })(t0);
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      const id = trigger.dataset.machineFinishTrigger;
      if (!id) return;
      event.preventDefault();
      setActive(id);
      const target = document.querySelector(`[data-machine-finish-layout="${id}"] .pretitle-handwritten`);
      if (target) setTimeout(() => slowScrollTo(target), 50);
    });
  });

  const initialTrigger = Array.from(triggers).find((t) => t.dataset.initial === 'true');
  if (initialTrigger) {
    setActive(initialTrigger.dataset.machineFinishTrigger);
  } else {
    const visibleLayout = Array.from(layouts).find((l) => !l.hasAttribute('hidden'));
    if (visibleLayout) {
      setActive(visibleLayout.dataset.machineFinishLayout);
    }
  }
})();

(() => {
  const cards = document.querySelectorAll('.image-hotspots__point--card');
  if (!cards.length) return;

  const section = cards[0].closest('.image-hotspots');
  const img = section?.querySelector('.image-hotspots__image');
  const source = section?.querySelector('picture source');
  const defaultDt = img?.src;
  const defaultMb = source?.srcset;

  const setImage = (dt, mb) => {
    if (img && dt) img.src = dt;
    if (source && mb) source.srcset = mb;
  };

  cards.forEach((point) => {
    const toggle = point.querySelector('.image-hotspots__card-toggle');
    const card = point.querySelector('.image-hotspots__card');
    if (!toggle || !card) return;

    toggle.addEventListener('click', () => {
      const open = !point.classList.contains('is-open');
      cards.forEach((other) => {
        const otherToggle = other.querySelector('.image-hotspots__card-toggle');
        const otherCard = other.querySelector('.image-hotspots__card');
        other.classList.remove('is-open');
        if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        if (otherCard) otherCard.setAttribute('hidden', '');
      });
      if (open) {
        point.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        card.removeAttribute('hidden');
        setImage(point.dataset.activeImageDt, point.dataset.activeImageMb);
      } else {
        setImage(defaultDt, defaultMb);
      }
    });
  });
})();
